/* 🤖 this file was generated by svg-to-ts*/
export const iconLevelUp = {
  name: 'level_up',
  data: `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24.5 3.5H21.5V2C21.5 1.175 20.825 0.5 20 0.5H8C7.175 0.5 6.5 1.175 6.5 2V3.5H3.5C1.85 3.5 0.5 4.85 0.5 6.5V8C0.5 11.825 3.38 14.945 7.085 15.41C8.03 17.66 10.055 19.355 12.5 19.85V24.5H8C7.175 24.5 6.5 25.175 6.5 26C6.5 26.825 7.175 27.5 8 27.5H20C20.825 27.5 21.5 26.825 21.5 26C21.5 25.175 20.825 24.5 20 24.5H15.5V19.85C17.945 19.355 19.97 17.66 20.915 15.41C24.62 14.945 27.5 11.825 27.5 8V6.5C27.5 4.85 26.15 3.5 24.5 3.5ZM3.5 8V6.5H6.5V12.23C4.76 11.6 3.5 9.95 3.5 8ZM24.5 8C24.5 9.95 23.24 11.6 21.5 12.23V6.5H24.5V8Z" fill="url(#paint0_linear_560_1089)"/>
  <defs>
  <linearGradient id="paint0_linear_560_1089" x1="1" y1="-7" x2="20.5" y2="28" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FFECA7" stop-opacity="0.97"/>
  <stop offset="1" stop-color="#F9BE50"/>
  </linearGradient>
  </defs>
  </svg>`,
}
